/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: '검색',
  search_no_results_1: '죄송합니다!',
  search_no_results_2: '이모지를 찾을 수 없습니다.',
  pick: '이모지를 선택하십시오...',
  add_custom: '사용자 지정 이모지 추가하기',
  categories_activity: '활동',
  categories_custom: '사용자 지정',
  categories_flags: '플래그',
  categories_foods: '식음료',
  categories_frequent: '자주 사용됨',
  categories_nature: '동물 및 자연',
  categories_objects: '사물',
  categories_people: '스마일 기호와 사람',
  categories_places: '여행 및 장소',
  categories_search: '검색 결과',
  categories_symbols: '기호',
  skins_choose: '기본 피부색 선택',
  skins_1: '기본값',
  skins_2: '밝게',
  skins_3: '중간 밝은',
  skins_4: '중간',
  skins_5: '중간 어두운',
  skins_6: '어두운',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
